module.exports = __webpack_public_path__ + "img/about-pelayanan.3fbd5876.png";